import { render, staticRenderFns } from "./ImportClientExcel.vue?vue&type=template&id=68774950&"
import script from "./ImportClientExcel.vue?vue&type=script&lang=js&"
export * from "./ImportClientExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports